import { promise } from '../../../helpers';
import { firebaseDeleteFile } from '../firebase';
import { updateTask } from './index';

const taskDeleteFile = ({ task, file }) => {
    // eslint-disable-next-line
    return (dispatch, getState, getFirebase) => {
        // -- update
        const update = (d, id) => dispatch(updateTask({ docId: id, data: d }));

        const nf = task.file.filter(f => f.storagePath !== file.storagePath);

        const newTask = { ...task };
        newTask.file = nf;
        delete newTask.id;

        update(newTask, task.id).then(() => dispatch(firebaseDeleteFile(file.storagePath)));

        return promise();
    };
};

export default taskDeleteFile;
